import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Typography,
  Container,
} from "@mui/material";
import menuService from "../services/menuService";
import {
  getReservations,
  cancelReservation,
} from "../services/reservationService";
import AdminNavbar from "./AdminNavbar";
import ReservationPage from "./ReservationPage"; // Import ReservationPage
import ContactPage from "./ContactPage"; // Import ContactPage

const AdminDashboard = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [isLocked, setIsLocked] = useState(false); // State to lock/unlock the reservation form
  const [isContactLocked, setIsContactLocked] = useState(false); // State to lock/unlock the contact form

  useEffect(() => {
    fetchMenuItems();
    fetchReservations();
  }, []);

  const fetchMenuItems = async () => {
    try {
      const items = await menuService.getMenuItems();
      setMenuItems(items);
    } catch (error) {
      console.error("Error fetching menu items", error);
    }
  };

  const fetchReservations = async () => {
    try {
      const res = await getReservations();
      setReservations(res);
    } catch (error) {
      console.error("Error fetching reservations", error);
    }
  };

  const handleDeleteMenuItem = async (id) => {
    await menuService.deleteMenuItem(id);
    fetchMenuItems();
  };

  const handleCancelReservation = async (id) => {
    await cancelReservation(id);
    fetchReservations();
  };

  const handleLogout = () => {
    localStorage.removeItem("token"); // Clear the authentication token
  };

  return (
    <div>
      <AdminNavbar onLogout={handleLogout} />
      <Container>
        <Typography variant="h4" gutterBottom>
          Admin Dashboard
        </Typography>
        {/* Lock Reservation Form Button */}
        <Button
          variant="outlined"
          color="secondary"
          sx={{
            marginBottom: "20px",
            fontFamily: "'Brilon', sans-serif",
          }}
          onClick={() => setIsLocked(!isLocked)}
        >
          {isLocked ? "Unlock Reservation Form" : "Lock Reservation Form"}
        </Button>
        {/* Lock Contact Form Button */}
        <Button
          variant="outlined"
          color="secondary"
          sx={{
            marginBottom: "20px",
            fontFamily: "'Brilon', sans-serif",
            marginLeft: "10px",
          }}
          onClick={() => setIsContactLocked(!isContactLocked)}
        >
          {isContactLocked ? "Unlock Contact Form" : "Lock Contact Form"}
        </Button>
        <h2>Menu Items</h2>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(menuItems) ? (
                menuItems.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.description}</TableCell>
                    <TableCell>{item.price}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => handleDeleteMenuItem(item.id)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>No menu items available</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <h2>Reservations</h2>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Party Size</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(reservations) ? (
                reservations.map((reservation) => (
                  <TableRow key={reservation.id}>
                    <TableCell>{reservation.name}</TableCell>
                    <TableCell>{reservation.phone}</TableCell>
                    <TableCell>{reservation.date}</TableCell>
                    <TableCell>{reservation.time}</TableCell>
                    <TableCell>{reservation.party_size}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => handleCancelReservation(reservation.id)}
                      >
                        Cancel
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>No reservations available</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* Pass isLocked to ReservationPage */}
        <ReservationPage isLocked={isLocked} />
        {/* Pass isContactLocked to ContactPage */}
        <ContactPage isLocked={isContactLocked} />
      </Container>
    </div>
  );
};

export default AdminDashboard;
